/* WithStoryRing — wraps a small avatar with an ORIO gradient ring when the
   given user_id is in the `unseen` Set (users with active stories the caller
   has NOT yet viewed).

   Usage:
     const { unseen } = useUnseenStories(userIds);
     <WithStoryRing unseen={unseen} userId={u.id} size={40}>
       <img src={u.photo_url} className="..." />
     </WithStoryRing>
*/
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useUnseenStories(userIds) {
  const [unseen, setUnseen] = useState(() => new Set());
  const key = (userIds || []).filter(Boolean).sort().join(",");
  useEffect(() => {
    if (!key) return;
    let cancelled = false;
    api.get("/stories/have-active", { params: { user_ids: key } })
      .then(({ data }) => {
        if (!cancelled) setUnseen(new Set(data.unseen || []));
      }).catch(() => {});
    return () => { cancelled = true; };
  }, [key]);
  return { unseen };
}

export default function WithStoryRing({ unseen, userId, size = 40, children, onClick }) {
  const active = unseen && userId && unseen.has(userId);
  const padding = active ? 2 : 0;
  return (
    <div
      onClick={onClick}
      className="rounded-full inline-flex items-center justify-center relative"
      style={{
        background: active
          ? "conic-gradient(from 0deg, #FF7A1A, #F4B83C, #FF7A1A, #F4B83C, #FF7A1A)"
          : "transparent",
        padding: `${padding}px`,
        width: size,
        height: size,
        cursor: onClick ? "pointer" : "inherit",
      }}
    >
      <div className="rounded-full overflow-hidden bg-white flex items-center justify-center"
        style={{ width: size - padding * 2, height: size - padding * 2 }}>
        {children}
      </div>
    </div>
  );
}
